import React from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import {
  AccountTree as FlowIcon,
  Apps as AppsIcon,
  Category as CategoryIcon,
  MiscellaneousServices as ServicesIcon,
  Business as TenantsIcon,
  FindInPage as EvaluateIcon,
} from '@mui/icons-material';
import { useLocation, useNavigate, Outlet } from 'react-router-dom';
import PageSkeleton from './PageSkeleton';

const clearanceTabs = [
  { label: 'Flow', path: '/clearance/flow', icon: <FlowIcon /> },
  { label: 'Applications', path: '/clearance/applications', icon: <AppsIcon /> },
  { label: 'Operation Contexts', path: '/clearance/operation-contexts', icon: <CategoryIcon /> },
  { label: 'Services', path: '/clearance/services', icon: <ServicesIcon /> },
  { label: 'Tenants', path: '/clearance/tenants', icon: <TenantsIcon /> },
  { label: 'Evaluate', path: '/clearance/evaluate', icon: <EvaluateIcon /> },
];

const ClearanceLayout: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Match current tab — exact match for /clearance, startsWith for sub-paths
  const currentTab = clearanceTabs.findIndex((tab) =>
    tab.path === '/clearance/flow'
      ? location.pathname === '/clearance' || location.pathname === '/clearance/flow' || location.pathname === '/clearance/visualization'
      : location.pathname.startsWith(tab.path),
  );

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', flexShrink: 0 }}>
        <Tabs
          value={currentTab === -1 ? 0 : currentTab}
          onChange={(_, newValue) => navigate(clearanceTabs[newValue].path)}
          variant="scrollable"
          scrollButtons="auto"
          sx={{ minHeight: 42 }}
        >
          {clearanceTabs.map((tab) => (
            <Tab
              key={tab.path}
              icon={tab.icon}
              iconPosition="start"
              label={tab.label}
              sx={{ minHeight: 42, py: 0, textTransform: 'none', fontSize: '0.85rem' }}
            />
          ))}
        </Tabs>
      </Box>
      <Box sx={{ flex: 1, overflow: 'auto' }}>
        {/* Keeps this section's tab bar on screen while the next tab's chunk loads. */}
        <React.Suspense fallback={<PageSkeleton />}>
          <Outlet />
        </React.Suspense>
      </Box>
    </Box>
  );
};

export default ClearanceLayout;


